export default __webpack_public_path__ + "assets/images/sulphur_69a909c6421cb427a22e6c24335fa2f4.jpg";